export default "__VITE_PUBLIC_ASSET__c016b30d__"